// extracted by mini-css-extract-plugin
export var container = "ResponseExample2025-module--container--0ae31";